export default
	{
		bankReportName: "Raport banca",
		clientMandateName: "Mandate Clienti",
		paymentsName: "Tranzactii",
		reportTypeLabel: "Tip Raport",
		uploadBankReport: "Incarca raportul bancar",
		uploadFileLabel: "Selecteaza fisierul",
		uploadButtonLabel: "Incarca fisierul",
		errorBankReportUploadMessage: "Fisierul nu a fost incarcat cu succes",
		reportUploadError_NO_CONTENT: "Te rugam sa incarci un fisier",
		reportUploadError_NO_TYPE: "Te rugam sa alegi tipul de raport",
		reportUploadSuccess: "Fisierul a fost incarcat cu succes",
		taxNumberLabel: "Cod fiscal",
		mandateNameLabel: "Nume",
		mandateStatusLabel: "Status",
		mandateCreatedLabel: "Creat la",
		seeDetailsLabel: "Vezi detalii",
		mandateUmrLabel : "UMR",
		mandateReferenceLabel : "Referinta (BCR)",
		mandateLimitAmountLabel : "Suma limita",
		validFromLabel: "Valid de la",
		validToLabel: "Valid pana la",
		customerIdentifierLabel: "Cod Up",
		customerTypeLabel: "Tip",
		productLabel: "Produs",
		mandateIbanLabel: "IBAN",
		companyTypeLabel: "Tip companie",
		companyCodeLabel: "Cod companie",
		companyNameLabel: "Nume",
		invoiceNumberLabel: "Nr. factura",
		companyType_AF: "Afiliat",
		companyType_CL: "Client",
		companyType_: "Selecteaza",
		product_0: "",
		product_11: "Up Dejun",
		product_12: "Up Vacanta",
		product_13: "Up Cadou",
		product_14: "Up Cultura",
		product_15: "Up Social",
		invoiceStatus_: "",
		invoiceStatus_P: "In procesare",
		invoiceStatus_N: "Generata",
		invoiceStatus_V: "Finalizata",
		invoiceStatus_E: "Eroare",
		mandateStatus_ : "",
		mandateStatus_A : "Activ",
		mandateStatus_E : "Expirat",
		customerStatus_A : "Activ",
		customerStatus_N : "Nou",
		customerStatus_D : "Dezactivat",
		customerStatus_E : "Expirat",
		invoiceReferenceLabel : "Referinta (BCR)",
		invoiceAmountLabel : "Valoare",
		noMandateLabel: "Nu exista mandate care sa indeplineasca criteriile selectate",
		noCustomerInvoiceLabel: "Nu exista facturi care sa indeplineasca criteriile selectate"
	}
	;
